"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_FILE_SIZE = exports.FILES_FIELD = void 0;
// export BulkUploadCountButton from './bulkUploadCountButton';
// export BulkUploadErrorList from './bulkUploadErrorList';
// export CSVUploader from './csvUploader';
var FILES_FIELD = 3;
exports.FILES_FIELD = FILES_FIELD;
var MAX_FILE_SIZE = 20000000;
exports.MAX_FILE_SIZE = MAX_FILE_SIZE;